import clsx from 'clsx';
import React from 'react';

import { styled } from 'netline-ui';
import { AboutMainModuleItem } from 'types';

import styles, { moduleVersionClasses } from './ModuleVersion.styles';

const ModuleVersionRoot = styled('div', { name: moduleVersionClasses.$name })(styles);

type ModuleVersionRowProps = {
  id: string;
  name: string;
  version: string;
  subModule: boolean;
  active?: boolean;
};

const ModuleVersionRow = ({ id, name, version, active = false, subModule = false }: ModuleVersionRowProps) => {
  return (
    <div key={id} className={moduleVersionClasses.row}>
      <div
        className={clsx(
          moduleVersionClasses.appNameColumn,
          moduleVersionClasses[subModule ? 'subModuleName' : 'mainModuleName'],
          { [moduleVersionClasses.activeModule]: !subModule && active },
        )}
      >
        {name}
      </div>
      <span
        className={clsx(moduleVersionClasses[subModule ? 'subModuleVersion' : 'mainModuleVersion'], {
          [moduleVersionClasses.activeModule]: active,
        })}
      >
        {version}
      </span>
    </div>
  );
};

const ModuleVersion = ({ moduleVersions }: { moduleVersions: AboutMainModuleItem[] }) => {
  return (
    <ModuleVersionRoot>
      {moduleVersions.map(({ id, name, version, subModules }, moduleIndex) => (
        <div key={id} className={moduleVersionClasses.content}>
          <ModuleVersionRow
            key={id}
            id={id}
            name={name}
            version={version}
            subModule={false}
            active={moduleIndex === 0}
          />
          {subModules?.map(({ id: subModuleId, name: subModuleName, version: subModuleVersion }) => (
            <ModuleVersionRow
              key={subModuleId}
              id={subModuleId}
              name={subModuleName}
              version={subModuleVersion}
              subModule
            />
          ))}
        </div>
      ))}
    </ModuleVersionRoot>
  );
};

export default ModuleVersion;
